import {
    request
} from "./request";

export function downloadFiles(name) {
    return request({
        url: '/ascancer/api/download/files/',
        params: {
            name
        },
        responseType: 'blob'
    })
}

export function getDownloadPageSummary() {
    return request({
        url: '/ascancer/api/download/summary'
    })
}